import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Slide, Box } from '@mui/material';
import { BsDashCircleFill } from "react-icons/bs";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RDialog({ title = "Test", fullScreen = false, open = false, handleClose = () => { }, children }) {

    return (
        <React.Fragment>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                sx={{ background: 'white' }}
            >
                <Box display={'flex'} alignItems={'center'}
                    justifyContent={'space-between'}
                    sx={{ borderRadius: '20 20 0 0', px: 2, py: 1 }} className="tab-button active">
                    <Typography fontSize={14}>{title}</Typography>
                    <BsDashCircleFill onClick={handleClose} />
                </Box>
                <Box sx={{ borderRadius: 20, p: 3 }}>
                    {children}
                </Box>
            </Dialog>
        </React.Fragment>
    );
}
